import * as yup from 'yup'

export const societyWebsiteFAQQuestionCreateSchema = yup
  .object({
    question: yup.string().required(),
    answer: yup.string().required(),
    section: yup.string(),
  })
  .required()
